import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style16({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="originalName"
      onClick={onClick}
    />
  );
}
